import { useCallback } from "react"

import { getUserInfo } from "@/services"
import { auth } from "@/utils/auth"

export const useFetchRole = (dispatch: React.Dispatch<any>) => {
    const handleFetchRole = useCallback(
        async (token: string) => {
            auth.setToken(token)

            const { code, data } = await getUserInfo(token)

            if (code === 0) {
                dispatch({
                    type: "updateContext",
                    payload: {
                        user: {
                            ...data,
                        },
                        hasRole: true,
                    },
                })

                return {
                    channelMasterId: data.channelId,
                    uid: data.uid,
                    nickName: data.nickName,
                }
            }

            dispatch({
                type: "updateContext",
                payload: {
                    user: null,
                },
            })
            return null
        },
        [dispatch]
    )
    return handleFetchRole
}
